module.exports = __webpack_public_path__ + "static/img/2.e14a18a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/people/aleksis/2.jpg
// module id = 40iT
// module chunks = 0